import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import type React from 'react'
import { useFormatter } from '../../../../../../../api/useFormatter'

interface IProps {
  components: Gravitate.Order['component_paths']
  selectedMarket: string
}

export const LoadSummaryCard: React.FC<IProps> = ({ components, selectedMarket }) => {
  const accentColor = 'var(--theme-color-1)'
  const textColor = 'secondary'
  const formatter = useFormatter({ marketOverride: selectedMarket })

  return (
    <Horizontal
      style={{
        border: `1px solid ${accentColor}`,
        borderRadius: '4px',
        gap: '2em',
      }}
      background='bg-2'
      className='p-4'
    >
      <Texto appearance={textColor} category='h5' className=' pb-2'>
        LOADS
      </Texto>
      <Horizontal>
        {components?.map((c, index) => (
          <Vertical key={`load-summary-${index}`} className='ml-3'>
            <Texto align='right' category='h5' weight='bold'>
              {formatter.formatVolume(c.volume, true)}
            </Texto>
            <Texto align='right' appearance={textColor} weight={600}>
              {c.component_product_name}
            </Texto>
          </Vertical>
        ))}
      </Horizontal>
    </Horizontal>
  )
}
